export default function PreviewIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="185" height="122" viewBox="0 0 185 122" fill="none">
      <g filter="url(#filter0_d_413_4148)">
        <path d="M94.4771 85.488L94.4771 98.3113" stroke="#848199" strokeWidth="0.990845" strokeDasharray="1.03 2.06" />
        <path d="M118.708 55.3789V28.496" stroke="#848199" strokeWidth="0.990845" strokeDasharray="1.03 2.06" />
        <path
          d="M52.3424 46.0739C52.5358 45.8805 52.5358 45.5668 52.3424 45.3733L49.1895 42.2205C48.996 42.027 48.6823 42.027 48.4889 42.2205C48.2954 42.4139 48.2954 42.7276 48.4889 42.9211L51.2914 45.7236L48.4889 48.5262C48.2954 48.7196 48.2954 49.0333 48.4889 49.2268C48.6823 49.4203 48.996 49.4203 49.1895 49.2268L52.3424 46.0739ZM30.9216 45.7236V46.2191H51.992V45.7236V45.2282H30.9216V45.7236Z"
          fill="#848199"
        />
        <rect x="8.98901" y="35.6196" width="28.7414" height="20.4032" rx="4.47148" fill="#E9DAFE" />
        <rect
          x="9.70596"
          y="36.3366"
          width="27.3075"
          height="18.9693"
          rx="3.75453"
          stroke="#AB87E2"
          strokeOpacity="0.9"
          strokeWidth="1.43389"
        />
        <rect x="15.8425" y="45.2329" width="15.0777" height="1.3707" rx="0.685348" fill="#B18FE5" />
        <rect
          x="53.8747"
          y="39.1864"
          width="28.4869"
          height="11.3893"
          rx="3.75453"
          fill="#9CDBC5"
          stroke="#00B875"
          strokeWidth="1.43389"
        />
        <rect x="61.0754" y="43.8625" width="13.707" height="1.3707" rx="0.685348" fill="#00B875" />
        <rect
          x="80.9459"
          y="96.1793"
          width="28.4869"
          height="11.3893"
          rx="3.75453"
          fill="#CBE2F7"
          stroke="#2198FF"
          strokeWidth="1.43389"
        />
        <rect x="87.8042" y="101.431" width="15.0777" height="1.3707" rx="0.685348" fill="#2198FF" />
        <rect x="104.451" y="47.991" width="28.7414" height="20.3994" rx="4.47148" fill="#E9DAFE" />
        <rect
          x="105.168"
          y="48.7079"
          width="27.3075"
          height="18.9655"
          rx="3.75453"
          stroke="#AB87E2"
          strokeOpacity="0.9"
          strokeWidth="1.43389"
        />
        <rect x="111.792" y="57.5691" width="13.707" height="1.3707" rx="0.685348" fill="#B18FE5" />
      </g>
      <rect
        x="105.467"
        y="14.4004"
        width="18.931"
        height="18.931"
        rx="1.67697"
        transform="rotate(-45 105.467 14.4004)"
        fill="#FFE7BE"
        stroke="#F5B53D"
        strokeWidth="1.43389"
      />
      <rect x="113.162" y="13.7065" width="10.9656" height="1.3707" rx="0.685348" fill="#F5B53D" />
      <circle cx="170.704" cy="42.0312" r="12.8187" fill="#F1A0C3" stroke="#E9478B" strokeWidth="1.43389" />
      <rect x="163.877" y="41.1206" width="13.707" height="1.3707" rx="0.685348" fill="#E9478B" />
      <path
        d="M105.511 14.5956C105.703 14.4035 105.703 14.0921 105.511 13.9L102.381 10.7698C102.189 10.5777 101.877 10.5777 101.685 10.7698C101.493 10.9619 101.493 11.2733 101.685 11.4654L104.467 14.2478L101.685 17.0302C101.493 17.2223 101.493 17.5337 101.685 17.7258C101.877 17.9179 102.189 17.9179 102.381 17.7258L105.511 14.5956ZM83.0786 44.881V45.3729H87.1559V44.881V44.3892H83.0786V44.881ZM91.6274 40.4096H92.1193V18.7193H91.6274H91.1356V40.4096H91.6274ZM96.0989 14.2478V14.7397H105.163V14.2478V13.7559H96.0989V14.2478ZM91.6274 18.7193H92.1193C92.1193 16.5214 93.901 14.7397 96.0989 14.7397V14.2478V13.7559C93.3577 13.7559 91.1356 15.9781 91.1356 18.7193H91.6274ZM87.1559 44.881V45.3729C89.8971 45.3729 92.1193 43.1507 92.1193 40.4096H91.6274H91.1356C91.1356 42.6074 89.3538 44.3892 87.1559 44.3892V44.881Z"
        fill="#848199"
      />
      <path
        d="M156.091 43.0915C156.283 42.8994 156.283 42.5879 156.091 42.3959L152.961 39.2657C152.769 39.0736 152.458 39.0736 152.266 39.2657C152.074 39.4577 152.074 39.7692 152.266 39.9613L155.048 42.7437L152.266 45.526C152.074 45.7181 152.074 46.0296 152.266 46.2216C152.458 46.4137 152.769 46.4137 152.961 46.2216L156.091 43.0915ZM132.947 58.4165V58.9083H137.3V58.4165V57.9246H132.947V58.4165ZM141.771 53.945H142.263V47.2151H141.771H141.279V53.945H141.771ZM146.243 42.7437V43.2355H155.744V42.7437V42.2518H146.243V42.7437ZM141.771 47.2151H142.263C142.263 45.0172 144.045 43.2355 146.243 43.2355V42.7437V42.2518C143.502 42.2518 141.279 44.474 141.279 47.2151H141.771ZM137.3 58.4165V58.9083C140.041 58.9083 142.263 56.6862 142.263 53.945H141.771H141.279C141.279 56.1429 139.498 57.9246 137.3 57.9246V58.4165Z"
        fill="#848199"
      />
      <path
        d="M119.046 68.9422C118.854 68.7501 118.543 68.7501 118.351 68.9422L115.22 72.0724C115.028 72.2645 115.028 72.5759 115.22 72.768C115.412 72.9601 115.724 72.9601 115.916 72.768L118.698 69.9856L121.481 72.768C121.673 72.9601 121.984 72.9601 122.176 72.768C122.368 72.5759 122.368 72.2645 122.176 72.0724L119.046 68.9422ZM68.8303 51.2925H68.3385V81.0162H68.8303H69.3222V51.2925H68.8303ZM73.3018 85.4877V85.9796H114.227V85.4877V84.9959H73.3018V85.4877ZM118.698 81.0163H119.19V69.29H118.698H118.207V81.0163H118.698ZM114.227 85.4877V85.9796C116.968 85.9796 119.19 83.7574 119.19 81.0163H118.698H118.207C118.207 83.2141 116.425 84.9959 114.227 84.9959V85.4877ZM68.8303 81.0162H68.3385C68.3385 83.7574 70.5606 85.9796 73.3018 85.9796V85.4877V84.9959C71.1039 84.9959 69.3222 83.2141 69.3222 81.0162H68.8303Z"
        fill="#848199"
      />
      <defs>
        <filter
          id="filter0_d_413_4148"
          x="-4.3869e-05"
          y="24.0016"
          width="142.182"
          height="97.7677"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.49453" />
          <feGaussianBlur stdDeviation="4.49453" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_413_4148" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_413_4148" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
